import abstractModel from '../../core/MercatelyModel';
import { serializeParams } from '../../util/urlUtils';

const csrfToken = document.querySelector('[name=csrf-token]').content;
const resource = '/api/mia/chatbot/carts';

const model = abstractModel(resource);
const parentGet = model.get;
const parentPost = model.post;
const parentPatch = model.patch;

const cartPath = (customerId) => `${resource}/${encodeURIComponent(customerId)}`;

model.retrieve = (customerId) => {
  return parentGet({}, { path: cartPath(customerId) });
};

model.addItems = (customerId, items) => {
  return parentPost({ items }, { path: `${cartPath(customerId)}/items`, csrfToken });
};

model.removeItems = (customerId, items) => {
  return parentPost({ items }, { path: `${cartPath(customerId)}/items/remove`, csrfToken });
};

model.updateItems = (customerId, items) => {
  return parentPatch({ items }, { path: `${cartPath(customerId)}/items/update`, csrfToken });
};

model.reset = (customerId) => {
  return parentPost({}, { path: `${cartPath(customerId)}/reset`, csrfToken });
};

model.listHistory = (customerId, params = {}) => {
  const queryString = serializeParams(params);
  const path = `${cartPath(customerId)}/history`;
  return parentGet({}, { path: queryString ? `${path}?${queryString}` : path });
};

export default model;
